import type { FC, ReactNode } from 'react';
import type { Placement } from '@floating-ui/react';
import { cx } from '@linaria/atomic';
import { Button, PopoverMenu, PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';
import { styles } from '../feature-promotion-banner.styles';
import type { FeaturePromotionBannerDismissItem } from '../feature-promotion-banner.types';

export interface FeaturePromotionBannerActionsProps {
  children: ReactNode;
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerActions: FC<FeaturePromotionBannerActionsProps> = ({
  children,
  className,
  testId,
}) => {
  return (
    <div className={cx(styles.actions, className)} data-testid={testId}>
      {children}
    </div>
  );
};

export interface FeaturePromotionBannerDismissMenuProps {
  label?: ReactNode;
  trackingId?: string;
  placement?: Placement;
  items: FeaturePromotionBannerDismissItem[];
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerDismissMenu: FC<FeaturePromotionBannerDismissMenuProps> = ({
  label = 'Maybe Later',
  trackingId,
  placement = 'bottom-start',
  items,
  className,
  testId,
}) => {
  const { getTriggerProps, getMenuProps, getItemProps } = usePopoverMenu({ placement });

  return (
    <>
      <Button
        variant='tertiary'
        {...getTriggerProps()}
        trackingId={trackingId}
        className={cx(styles.dismissButton, className)}
        data-testid={testId}
      >
        {label}
      </Button>

      <PopoverMenu {...getMenuProps()}>
        {items.map((item, index) => (
          <PopoverMenuItem
            key={index}
            {...getItemProps({ index, onClick: item.onClick })}
            trackingId={item.trackingId}
            data-testid={item.testId}
          >
            {item.label}
          </PopoverMenuItem>
        ))}
      </PopoverMenu>
    </>
  );
};
